"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M5.7275 9.293L5.1975 9.823C5.0995 9.921 5.0995 10.079 5.1975 10.177L5.7275 10.707C5.9145 10.895 6.0205 11.149 6.0205 11.414V13C6.0205 13.553 6.4685 14 7.0205 14H7.5205C7.7965 14 8.0205 14.224 8.0205 14.5V15.5C8.0205 15.776 7.7965 16 7.5205 16H4.9005C4.4145 16 4.0205 15.605 4.0205 15.12V12.236C4.0205 11.479 3.9785 10.786 3.2835 10.447C2.9055 10.263 2.9055 9.737 3.2835 9.553C3.9785 9.214 4.0205 8.522 4.0205 7.764V4.835C4.0205 4.374 4.3945 4 4.8545 4H7.5205C7.7965 4 8.0205 4.224 8.0205 4.5V5.5C8.0205 5.776 7.7965 6 7.5205 6H7.0205C6.4685 6 6.0205 6.447 6.0205 7V8.586C6.0205 8.851 5.9145 9.106 5.7275 9.293ZM14.3134 9.293C14.1264 9.106 14.0204 8.851 14.0204 8.586V7C14.0204 6.447 13.5724 6 13.0204 6H12.5204C12.2444 6 12.0204 5.776 12.0204 5.5V4.5C12.0204 4.224 12.2444 4 12.5204 4H15.1864C15.6464 4 16.0204 4.374 16.0204 4.835V7.764C16.0204 8.522 16.0624 9.214 16.7574 9.553C17.1354 9.737 17.1354 10.263 16.7574 10.447C16.0624 10.786 16.0204 11.479 16.0204 12.236V15.12C16.0204 15.605 15.6264 16 15.1404 16H12.5204C12.2444 16 12.0204 15.776 12.0204 15.5V14.5C12.0204 14.224 12.2444 14 12.5204 14H13.0204C13.5724 14 14.0204 13.553 14.0204 13V11.414C14.0204 11.149 14.1264 10.895 14.3134 10.707L14.8434 10.177C14.9414 10.079 14.9414 9.921 14.8434 9.823L14.3134 9.293Z",
    fill: "#727B7F"
  }));
};